const React = require('react');
const delay = require('mn-utils/delay');
const noop = require('mn-utils/noop');
const changeProviderProvider = require('mn-utils/changeProviderProvider');
const withState = require('../../../../utils/withState');
const {
  backLocation,
} = require('../../../../router');
const {
  adminTerminal$,
  openV1PopupInfo,
} = require('../../../../emitters/popup');
const {
  apiAdminTerminalsAdd,
  apiAdminTerminalsEdit,
  apiAdminTerminalsGet,
} = require('../../../../api/admin/terminals');
const TerminalEdit = require('./TerminalEdit');

const TerminalEditSmart = withState((setState, self, onMount) => {
  const changeProvider = changeProviderProvider(setState);
  const handleChangeName = changeProvider('name');
  const handleChangeImei = changeProvider('imei');
  const handleMerchantId = changeProvider('merchant_id');

  let _id;
  let _cancel = noop;
  let _hasEdit;
  function update() {
    _hasEdit = _id !== 'new';
    if (!_hasEdit) return;
    _cancel = delay(() => {
      setState({
        getloading: true,
      });
      _cancel = apiAdminTerminalsGet({
        id: '' + _id,
      }).finally((error, item) => {
        console.log({_id, item});
        setState({
          getloading: false,
          ...(item || {}),
          blockIMEI: !!item.imei
        });
      }).cancel;
    });
  }

  onMount(() => {
    return () => {
      _cancel();
    };
  });

  return (state, props) => {
    const options = props.options || {};
    const {
      id,
      callback,
    } = options;
    _id === id || id && update(_id = id);

    return (
      <TerminalEdit
        state={{
          ...state,
          loading: state.loading || state.getLoading,
        }}
        blockIMEI={state.blockIMEI}
        handleChangeName={handleChangeName}
        handleMerchantId={handleMerchantId}
        handleChangeImei={handleChangeImei}
        handleChangeStatus={(status) => setState({status})}
        handleChangeColor={(color) => setState({color})}
        onSend={(params) => {
          setState({
            loading: true,
          });
          (
          _hasEdit
            ? apiAdminTerminalsEdit({
              ...params,
              id,
            })
            : apiAdminTerminalsAdd(params)
          ).then(() => {
            setState({
              loading: false,
            });
            backLocation();
            callback && callback();
            openV1PopupInfo([
              'Information',
              _hasEdit
                ? 'Terminal has been updated'
                : 'Terminal has been appended',
            ]);
          });
        }}
        onTry={() => {
          setState({
            clicked: true,
          });
        }}
        skip={_hasEdit}
      />
    );
  };
}, {});


// eslint-disable-next-line
module.exports = require('../../../containers/PopupProviderC')(adminTerminal$, (options) => {
  return (<TerminalEditSmart options={options}/>);
});
